import type { ProductProps } from '../index';
import { ProductPage } from '../shared';

export default function Product(props: ProductProps) {
  return <ProductPage {...props} font="serif" kicker="Peça exclusiva" ctaLabel="Adquirir peça exclusiva" />;
}
